import styled from "styled-components";

const StickyWrapper = styled.div`
  height: 56px;
  width: 100vw;
  background: rgba(0, 0, 0, 0.35);
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 12px;
  @media print {
    display: none;
  }
`;

export default StickyWrapper;
